import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

export default function NotFound() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <>
      <SEO
        title={isRTL ? '404 | وجود لينك' : '404 | Wojod Link'}
        description="Page not found"
        noindex
      />

      <div className="not-found">
        <div>
          <h1>404</h1>
          <h2>{t('notFound.title')}</h2>
          <p>{t('notFound.description')}</p>
          <Link to="/" className="btn btn-primary">
            {t('notFound.goHome')} <i className={`fas fa-arrow-${isRTL ? 'left' : 'right'}`} />
          </Link>
        </div>
      </div>
    </>
  );
}
